import api from './api';

export async function getNotificationPreferences() {
  const response = await api.get('/notification-preferences');
  return response.data;
}

export async function updateNotificationPreferences(preferences) {
  const response = await api.put('/notification-preferences', preferences);
  return response.data;
}

export async function getOwnerBookingNotificationSettings() {
  const response = await api.get('/owner/booking-notification-settings');
  return response.data;
}

export async function updateOwnerBookingNotificationSettings(settings) {
  const response = await api.put('/owner/booking-notification-settings', settings);
  return response.data;
}
